import { Stack, Avatar, Typography, Button, Link } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue, FloatingVector, VideoCircle } from 'Images';

export interface ISupplierCard {
  supplierLogo: string;
  supplierLogoAlt: string;
  supplierVideoHref: string;
  keyIndex: number;
  onClick: () => void;
}

export const SupplierCard = ({
  supplierLogo,
  supplierLogoAlt,
  supplierVideoHref,
  keyIndex,
  onClick,
}: ISupplierCard) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);

  return (
    <Stack
      bgcolor={'#fff'}
      key={keyIndex}
      alignItems={'center'}
      borderRadius={'16px'}
      padding={'24px 0px 0px'}
      boxShadow={'0px 3px 21px rgba(23, 82, 175, 0.15)'}
      sx={{
        backdropFilter: 'blur(13px)',
      }}
    >
      <Stack gap={'16px'} alignItems={'center'} paddingBottom={'33px'}>
        <Avatar
          src={supplierLogo}
          alt=''
          sx={{
            width: isDesktop ? '268px' : '121px',
            height: isDesktop ? '76px' : '36px',
          }}
        />
        <Stack
          direction={'row'}
          alignItems={isDesktop ? 'center' : 'flex-start'}
          justifyContent={'center'}
          gap={'8px'}
          width={isDesktop ? '200px' : '120px'}
        >
          <Avatar
            src={VideoCircle}
            alt={''}
            sx={{
              width: '20px',
              height: '20px',
              mt: isDesktop ? undefined : '5px',
            }}
          />
          <Link
            underline={'hover'}
            href={supplierVideoHref}
            target={'_blank'}
            aria-label={`${dictionary.treatmentSupplier.watchTutorial} ${supplierLogoAlt}`}
          >
            <Typography variant={'body6'}>
              {dictionary.treatmentSupplier.watchTutorial}
            </Typography>
          </Link>
        </Stack>
      </Stack>
      <Button
        onClick={onClick}
        sx={{
          bgcolor: 'primary.shade_100',
          width: '100%',
          borderRadius: '0',
          borderEndStartRadius: '16px',
          borderEndEndRadius: '16px',
          padding: '12px 10px',
          position: 'relative',
          '&:hover': {
            backgroundColor: 'primary.shade_100',
          },
        }}
        role='link'
      >
        <Typography variant={'body5'}>
          {dictionary.treatmentSupplier.order}
        </Typography>
        <Avatar
          src={ArrowBackBlue}
          alt=''
          sx={{ width: '16px', height: '16px' }}
        />
        <Avatar
          src={FloatingVector}
          alt=''
          sx={{ width: '100%', height: '100%', position: 'absolute' }}
        />
      </Button>
    </Stack>
  );
};
